import Layout from 'components/layout'
import { UserEntry } from 'modules/users/containers'
import s from './entrar.module.css'

export default function Entrar() {
  return (
    <Layout>
      <div className={s.root}>
        <div className={s.content}>
          <UserEntry />
        </div>
      </div>
    </Layout>
  )
}
